import {useEffect, useState, useRef} from "react";

const useOffsetTop = <T extends HTMLElement>() => {
    const ref = useRef<T>(null);
    const [offsetTop, setOffsetTop] = useState(0);

    useEffect(() => {
        updateOffset();
    });

    useEffect(() => {
        window.addEventListener("resize", updateOffset);
        window.addEventListener("scroll", updateOffset);

        return () => {
            window.removeEventListener("resize", updateOffset);
            window.removeEventListener("scroll", updateOffset);
        };
    }, []);

    const updateOffset = () => {
        setTimeout(() => {
            if (ref.current) {
                setOffsetTop(ref.current.getBoundingClientRect().top);
            }
        }, 250)
    };

    return {ref, offsetTop};
};

export default useOffsetTop;